var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96617 4.97998C6.8395 4.97998 6.71281 4.93333 6.61281 4.83333L4.48615 2.70667L2.35948 4.83333C2.16614 5.02667 1.84615 5.02667 1.65281 4.83333C1.45948 4.64 1.45948 4.32 1.65281 4.12667L4.13283 1.64665C4.22617 1.55331 4.35281 1.5 4.48615 1.5C4.61948 1.5 4.74617 1.55331 4.8395 1.64665L7.31948 4.12667C7.51281 4.32 7.51281 4.64 7.31948 4.83333C7.21948 4.93333 7.09283 4.97998 6.96617 4.97998Z",
    fill: "#4D5D6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48633 14.5C4.21299 14.5 3.98633 14.2733 3.98633 14V2C3.98633 1.72667 4.21299 1.5 4.48633 1.5C4.75966 1.5 4.98633 1.72667 4.98633 2V14C4.98633 14.2733 4.75966 14.5 4.48633 14.5Z",
    fill: "#4D5D6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5193 14.4998C11.386 14.4998 11.2593 14.4465 11.166 14.3532L8.68602 11.8731C8.49268 11.6798 8.49268 11.3598 8.68602 11.1665C8.87935 10.9732 9.19935 10.9732 9.39268 11.1665L11.5193 13.2932L13.646 11.1665C13.8393 10.9732 14.1593 10.9732 14.3527 11.1665C14.546 11.3598 14.546 11.6798 14.3527 11.8731L11.8727 14.3532C11.7793 14.4465 11.646 14.4998 11.5193 14.4998Z",
    fill: "#4D5D6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5137 14.5C11.2403 14.5 11.0137 14.2733 11.0137 14V2C11.0137 1.72667 11.2403 1.5 11.5137 1.5C11.787 1.5 12.0137 1.72667 12.0137 2V14C12.0137 14.2733 11.7937 14.5 11.5137 14.5Z",
    fill: "#4D5D6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow-3.9f8ac267efef420dd73a49fd2c3af951.svg";
export { ForwardRef as ReactComponent };